// extracted by mini-css-extract-plugin
module.exports = {"items":"Items_items__3Y0zI","column":"Items_column__1grpm"};